import AGSHighlightWins from "ags/states/ags-highlight-wins";
import { LLWildBonusResult } from "integration/builders/result/ll-wild-bonus-result-builder";
import { default as GameState, default as gameState } from "slotworks/model/game-state";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import Result from "slotworks/model/gameplay/records/results/result";
import GatewayResult, { GatewayType } from "model/gameplay/records/results/gateway-result";
import { GatewayResultBuilder } from "integration/builders/result/gateway-result-builder";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";

export default class CGHighlightWins extends AGSHighlightWins {

    public onEnter() {

        const game = gameState.getCurrentGame().getCurrentRecord();
        const hasWildBonusResult = game.getResultsOfType(LLWildBonusResult).length > 0;

        if (hasWildBonusResult) {
            return this.complete();
        }

        if (GameState.currentRecordHasSymbolWinResults() || GameState.currentRecordHasBonusWinResults()) {
            lightningBorderAnimationUtil.stop();
            super.onEnter();
        }
    }

    protected isCelebratedResult(win: Result) {
        const isSymbolWin = win instanceof SymbolWinResult;
        const isGatewayWin = win instanceof GatewayResult;

        return isSymbolWin || isGatewayWin;
    }
}
